// Interfaces
import { IScreen } from "shared/interfaces";
// Origin
import { OriginSize } from "shared/origin";
// Main
import { Main } from "screens/main";
// Services
import { GameService } from "screens/game/services";
// Mechanics
import { FillBurMechanic, BackgroundReleaseMechanicOld, DropTheElementMechanic } from "shared/mechanics";
import { BackgroundReleaseMechanic } from "shared/mechanics/backgroundRelease.mechanic";
import { EventBus } from "shared/emmiter";
import { FillBarService, FireBaseService, LoaderService, ResizeService, LanguageService, PopupsService, DiscountPopupService, SoundService } from "shared/services";
import { GameMarkup } from "./markup";
import { LevelObject } from "shared/levels";
import { MechanicsConfig, LevelsConfig } from "shared/config";
import gsap from "gsap";
import { BackgroundReleaseTutorial, FillBarTutorial, DropProductTutorial } from "shared/services/tutorials";
import { ScoreStorage, GameViewStorage, LocElementsStorage, IsMusicStartStorage } from "shared/storages";
import { PreloaderHelper } from "shared/helpers";

export class Game implements IScreen {
    private static _instance: Game = null;

    static get instance(): Game {
        if (Game._instance === null) {
            Game._instance = new Game();
        }
        return Game._instance;
    }


    public name: string = 'game_screen';
    private game: PIXI.Container;
    public screen: PIXI.Container;
    public currentMechanic;
    private resizeService: ResizeService;
    private destructAnimation;
    private destructSheet: PIXI.Spritesheet;
    private currentMechanicString: string;
    private GameService: GameService;
    private markup: GameMarkup;
    private mechanicElements = [];
    private level;
    public popups;
    private gameSubstate: PIXI.Container;

    public init(level): void {
        this.resizeService = new ResizeService();
        this.level = level;
        this.name = 'game_screen';
        this.screen = new PIXI.Container;
        this.game = new PIXI.Container;
        this.markup = new GameMarkup();
        this.screen.name = this.name;
        Main.instance.app.stage.addChild(this.screen);
        this.GameService = new GameService();
        FillBarService.reset();
        GameViewStorage.setIsView(true);
        this.initMap();
        this.createSubstate();
        this.addBtnListeners();
        // this.initDestructAnimation();
        this.sortContainerChildren(this.screen)
        this.changeMechanic(level);
    }

    private initDestructAnimation(): void {
        this.destructSheet = LoaderService.getResource('destruct_tile').spritesheet;
        this.destructAnimation = new PIXI.AnimatedSprite(this.destructSheet.animations['tile_explosion']);
        this.destructAnimation.name = 'destruct_anim';
        // this.destructAnimation.width = 355;
        // this.destructAnimation.height = 355;
        this.destructAnimation.loop = false;
        this.currentMechanic.addChild(this.destructAnimation);
    }

    public playAnimDestruct(frame, x, y): void {
        this.destructAnimation.x = x;
        this.destructAnimation.y = y;
        this.destructAnimation.gotoAndPlay(frame);
    }

    private createSubstate(): void {
        this.gameSubstate = new PIXI.Container;
        this.gameSubstate.name = 'substate'
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x191919);
        graphics.drawRect(0, 0, OriginSize.width, OriginSize.height);
        graphics.name = 'darken'
        graphics.alpha = 1;
        this.gameSubstate.addChild(graphics);
        this.gameSubstate.alpha = 0;
        this.gameSubstate.zIndex = 99998;
        this.screen.addChild(this.gameSubstate);
    }

    public blurScreen(state) {
        if (state) {
            const blur = new PIXI.filters.BlurFilter();
            blur.blur = 0;
            blur.enabled = true;
            this.screen.filters = [blur];
            gsap.to(blur, { blur: 10, duration: 0.2, ease: 'none' })
        } else {
            this.screen.filters = [];
        }
    }

    public toggleBlur(state: boolean) {
        const blur = new PIXI.filters.BlurFilter();
        if (state) {
            blur.blur = 0;
            blur.enabled = true;
            this.currentMechanic.filters = [blur];
            gsap.to(blur, { blur: 10, duration: 0.2, ease: 'none' })
        } else {
            gsap.to(this.gameSubstate, {
                alpha: 0.9, duration: 0.2, ease: 'none', onComplete: () => {
                    this.currentMechanic.mixTiles(false);
                }
            })
            // this.darkenMixSceen()
        }
    }

    public darkenMixSceen() {
        const screen = Main.instance.app.stage.getChildByName('mix_screen') as PIXI.Container;
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x191919);
        graphics.drawRect(this.currentMechanic.x, this.currentMechanic.y, this.currentMechanic.height, this.currentMechanic.width);
        graphics.name = 'darken'
        graphics.alpha = 0;
        screen.addChild(graphics);
        gsap.to(graphics, { alpha: 0.9, duration: 0.2, ease: 'none' })
    }

    public toggleMixScreen(state): void {
        const screen = Main.instance.app.stage.getChildByName('mix_screen') as PIXI.Container;

        if (!screen) {
            return;
        }

        if (state) {
            this.currentMechanic.interactive = false;
            gsap.to(screen, {
                alpha: 1, duration: 0.2, ease: 'none', onComplete: () => {
                    screen.interactive = true;
                }
            })
            this.toggleBlur(state);
        } else {
            gsap.to(screen, {
                alpha: 0, duration: 0.2, ease: 'none', onComplete: () => {
                    screen.interactive = false;
                }
            })
            gsap.to(this.gameSubstate, { alpha: 0, duration: 0.2, ease: 'none' });

            if (this.currentMechanic) {
                this.currentMechanic.filters = [];
            }
        }
    }

    public changeMechanic(level): void {
        IsMusicStartStorage.isCanStart = true;
        FillBarService.isGameEnd = false;
        const header = this.screen.getChildByName('header') as PIXI.Container;
        const mask = header.getChildByName('mask') as PIXI.Container;
        mask.y = 0;

        this.screen.removeChild(this.currentMechanic);
        for (let i = 0; i < this.mechanicElements.length; i++) {
            this.screen.removeChild(this.mechanicElements[i]);
        }

        this.currentMechanicString = LevelsConfig.levels[level.num].type;
        localStorage.setItem('current_mechanic', JSON.stringify(this.currentMechanicString));
        switch (this.currentMechanicString) {
            case 'fill_bar': {
                FillBarTutorial.toggleFillBarTutorial(true, this.screen);
                this.mechanicElements = this.GameService.createBar(this.screen);
                this.currentMechanic = new FillBurMechanic(level);
                break;
            }
            case 'background_release': {
                BackgroundReleaseTutorial.toggleBackgroundReleaseTutorial(true, this.screen);
                this.currentMechanic = new BackgroundReleaseMechanic(level);
                // this.currentMechanic = new BackgroundReleaseMechanicOld();
                break;
            }
            case 'drop_product': {
                DropProductTutorial.toggleDropProductTutorial(true, this.screen);
                this.mechanicElements = this.GameService.createProductCounter(this.screen);
                this.currentMechanic = new DropTheElementMechanic(level);
                // this.currentMechanic.y = this.currentMechanic.y - GameViewStorage.notFillBarShift;
                break;
            }
        }

        LanguageService.changeGameLanguage();

        const animationContainer = Main.instance.app.stage.getChildByName('animation_container');
        this.screen.addChild(this.currentMechanic);
        this.currentMechanic.name = 'current_mechanic';
        this.currentMechanic.x = 85;
        this.currentMechanic.y = this.screen.height / 2 - this.currentMechanic.height / 2;



        // this.currentMechanic.pivot.set(0, this.currentMechanic.height / 2);         
        animationContainer.x = 85;
        animationContainer.y = this.currentMechanic.y;
        GameViewStorage.gamePool = this.currentMechanic;
        GameViewStorage.originY = this.currentMechanic.y;
        this.resizeService.resizeScene(Main.instance.app);
        this.sortContainerChildren(Main.instance.app.stage);

        if (this.currentMechanicString === 'background_release') {
            this.currentMechanic.y = this.currentMechanic.y - GameViewStorage.mechanicShift;
        }
    }

    private initMap(): void {
        this.GameService.init(this.screen);
        this.GameService.createHeader(this.screen);
        this.GameService.createMixScreen(this.screen);

        const header = this.screen.getChildByName('header');
        this.sortContainerChildren(header);
    }

    private addBtnListeners(): void {
        const fillBarBtn = document.getElementById('fillBarBtn');
        const releaseBackBtn = document.getElementById('releaseBackBtn');
        const closePause = document.getElementById('closePause');
        const resumeGame = document.getElementById('resume_game');
        const exitGame = document.getElementById('exit_game');
        const pauseDiscount = document.getElementById('pause_discont');

        document.getElementById('mixBtn').addEventListener('click', () => {
            this.currentMechanic.mixTiles(true);
        })

        pauseDiscount.addEventListener('click', () => {
            DiscountPopupService.show(false, false);
        })

        exitGame.addEventListener('click', () => {
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'map screen',
                })
            }
            const pause = document.getElementById('pause');
            pause.style.display = 'none';
            PopupsService.openLosePopup(this.level.num, ScoreStorage.score);

            const elClone = exitGame.cloneNode(true);

            exitGame.parentNode.replaceChild(elClone, exitGame);
        })

        resumeGame.addEventListener('click', () => {
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'resume',
                })
            }

            const substate = document.getElementById('blackout_substate');
            const pause = document.getElementById('pause');
            substate.style.display = 'none';
            pause.style.display = 'none';
            this.blurScreen(false);
        })

        closePause.addEventListener('click', () => {
            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'resume',
                })

            }
            const substate = document.getElementById('blackout_substate');
            const pause = document.getElementById('pause');
            substate.style.display = 'none';
            pause.style.display = 'none';
            this.blurScreen(false);
        })

        fillBarBtn.addEventListener('click', () => {
            this.screen.removeChild(this.currentMechanic)
            EventBus.emit('reset_game');
            this.changeMechanic(1);
        })

        releaseBackBtn.addEventListener('click', () => {
            this.screen.removeChild(this.currentMechanic)
            EventBus.emit('reset_game');
            this.changeMechanic(2)
        })
    }

    private sortContainerChildren(container): void {
        container.children.sort((a, b) => {
            return a.zIndex - b.zIndex;
        });
    }

    public show(): void {
        PreloaderHelper.togglePreloader(false);
        this.screen.visible = true;
    }

    public hide(): void {
        this.screen.visible = false;
    }

    public destroy(): void {
        Main.instance.app.stage.removeChild(this.screen);
    }

}